<template>
    <main>
      <b-form-row>
        <b-form-checkbox v-model="isSearch" @change="decide" name="check-button" switch>
          Αναζήτηση βάσει ΑΣΜ
        </b-form-checkbox>
        <b-form-checkbox v-model="isAdvanced" @change="decide" name="check-button" switch style="margin-left: 2em">
          Σύνθετη αναζήτηση
        </b-form-checkbox>
      </b-form-row>
      <br>
      <br>
      <div v-if="isSearch && !isAdvanced">
        <b-card>
          <b-form v-on:submit.prevent="noop">
            <b-form-row>
              <b-input-group>
                <b-form-input type="text" placeholder="ΑΣΜ" v-model="searchedEfsa"
                              :state="efsaValidation"></b-form-input>
                <b-form-invalid-feedback :state="efsaValidation">
                  Ο Αριθμός Στρατιωτικού Μητρώου (ΑΣΜ) πρέπει να αποτελείται 11 ψηφία
                </b-form-invalid-feedback>
              </b-input-group>
            </b-form-row>
             <br>
            <b-row class="justify-content-center">
              <b-col md="1.5">
                <b-button block variant="primary" v-on:click="fetchSingleData" v-bind:disabled="!efsaValidation">
                  ΑΝΑΖΗΤΗΣΗ
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </div>
      <div v-if="isAdvanced && !isSearch">
        <b-card>
          <b-form>
            <b-form-row>
              <b-col md="6">
                <b-form-group label-for="name" label="Όνομα">
                  <b-form-input id="name" v-model="searchedFirstName" :state="advancedSearchValidation"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label-for="last_name" label="Επίθετο">
                  <b-form-input id="last_name" v-model="searchedLastName" :state="advancedSearchValidation"></b-form-input>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col md="6">
                <b-form-group label-for="email" label="Email">
                  <b-form-input id="email" v-model="searchedEmail" :state="advancedSearchValidation"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label-for="afm" label="ΑΦΜ">
                  <b-form-input id="afm" v-model="searchedAfm" :state="advancedSearchValidation"></b-form-input>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-invalid-feedback :state="advancedSearchValidation">
              Η συμπλήρωση τουλάχιστον ενός πεδίου αναζήτησης είναι απαραίτητη
            </b-form-invalid-feedback>

            <br>
            <b-row class="justify-content-center">
              <b-col md="3">
                <b-button variant="primary" v-on:click="fetchSingleData" v-bind:disabled="!advancedSearchValidation">
                  ΑΝΑΖΗΤΗΣΗ
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </div>
      <br>
        <b-row class="d-flex justify-content-center">
            <b-container fluid="lg" style="min-width: 1300px;">
                <span style="color: #7f7f7f">Σύνολο: {{ totalItems }}</span>
                <b-row align-h="end">
                    <b-col md="2">
                        <b-button v-if="selectedUsers.length>0" variant="danger" size="sm" v-b-modal.delete-modal>
                            <b-icon icon="trash-fill" aria-hidden="true"></b-icon>
                            Διαγραφή
                        </b-button>
                    </b-col>
                    <b-col md="2">
                        <b-button variant="success" size="sm" v-on:click="exportChanges" v-bind:hidden="isSearch">
                            <b-icon icon="cloud-download" aria-hidden="true"></b-icon>
                            Κατέβασμα σε excel
                        </b-button>
                    </b-col>
                </b-row>

                <b-row class="overflow-auto">
                    <b-table select-mode="multi" class="efedros-table" show-empty :items="unverifiedUsers"
                             :fields="fields"
                             selectable
                             @row-selected="onRowSelected"
                             :current-page="currentPage"
                             :per-page="0"></b-table>
                    <b-pagination size="md" :total-rows="totalItems" @change="pageChange" v-model="currentPage"
                                  :per-page="perPage"></b-pagination>
                </b-row>

              <b-modal id="delete-modal" title="Διαγραφή χρηστών" ok-variant="danger" @ok="deleteSelectedUsers" ok-title="Διαγραφή" cancel-title="Ακύρωση">
                    <p>Είστε σίγουρος ότι θέλετε να διαγράψετε τους χρήστες με ΑΦΜ:</p>
                    <tr v-for="user in selectedUsers">
                        <td>{{ user.afm }}</td>
                    </tr>
                </b-modal>
            </b-container>
        </b-row>
    </main>
</template>

<script>

import { HTTP } from "@/main";

export default {
    data: function () {
        return {
            selectedUsers: [],
            unverifiedUsers: [],
            isAdvanced: false,
            searchedEfsa: null,
            searchedFirstName: null,
            searchedLastName: null,
            searchedEmail: null,
            searchedAfm: null,
            isSearch: false,
            fields: [
                {
                    key: 'efSa',
                    label: 'ΣΑ'
                },
                {
                    key: 'afm',
                    label: 'ΑΦΜ'
                },
                {
                    key: 'firstName',
                    label: 'Όνομα'
                },
                {
                    key: 'lastName1',
                    label: 'Επίθετο'
                },
                {
                    key: 'fatherName',
                    label: 'Πατρώνυμο'
                },
                {
                    key: 'motherName',
                    label: 'Μητρώνυμο'
                },
                {
                    key: 'mhtrwoArrenwn',
                    label: 'Μητρώο Αρρένων'
                },
                {
                    key: 'mobileThl',
                    label: 'Κινητό Τηλέφωνο'
                },
                {
                    key: 'statheroThl',
                    label: 'Σταθερό Τηλέφωνο'
                },
                {
                    key: 'isAfmNotValid',
                    label: 'Καταχωρημένος χρήστης'
                },
                {
                    key: 'email',
                    label: 'E-mail'
                },
                {
                    key: 'date',
                    label: 'Ημερομηνία καταχώρησης'
                }
            ],
            currentPage: 1,
            perPage: 10,
            totalItems: 0
        };
    },

    computed: {
      efsaValidation() {
        // check if efsa contains exactly 11 digits
        return (/^\d+$/.test(this.searchedEfsa) && this.searchedEfsa.length === 11);
      },

      advancedSearchValidation() {
        // At least one search field has to be populated by the user
        return ((this.searchedFirstName != null && this.searchedFirstName !== "") ||
            (this.searchedLastName != null && this.searchedLastName !== "") ||
            (this.searchedAfm != null && this.searchedAfm !== "") ||
            (this.searchedEmail != null && this.searchedEmail !== ""))
      },

    },

    mounted() {
      this.fetchData()
    },

    methods: {
        deleteSelectedUsers() {
            let url = "/users/delete";
            this.selectedUsers.forEach( user => {
                HTTP.get(url + "/" + user.afm).then(_ => {
                    let index = this.unverifiedUsers.map(x => {
                        return x.afm;
                    }).indexOf(user.afm)
                    this.unverifiedUsers.splice(index, 1);

                    this.$bvToast.toast("Επιτυχημένη διαγραφή του χρήστη με ΑΦΜ " + user.afm, {
                        title: `Επιτυχία`,
                        variant: 'success',
                        solid: true
                    });
                }).catch((error) => {
                    this.$bvToast.toast("Αδύνατη διαγραφή του χρήστη με ΑΦΜ " + user.afm, {
                        title: `Αδύνατη διαγραφή`,
                        variant: 'danger',
                        solid: true
                    });
                    console.error(error);
                }).finally(() => {
                });
            })
        },
        onRowSelected(items) {
            this.selectedUsers = items;
        },
        pageChange(page) {
            this.currentPage = page;
            this.fetchData()
        },
        async decide() {
          if (this.isSearch || this.isAdvanced) {
            this.unverifiedUsers = []
            this.totalItems = 0;
            this.perPage = 10;
            this.currentPage = 1;
          }
          else {
            this.perPage = 10;
            this.currentPage = 1;
            this.fetchData();
          }
        },
        async fetchData() {

            let size = this.perPage == null ? 10 : this.perPage;
            let page = this.currentPage == null ? 0 : this.currentPage-1

            let url = "/admin/fetch-unverified-users?page=" + page + "&size=" + size + "";

            this.$store.dispatch('loading');

            HTTP.get(url).then(response => {
                if (response.data.responseData.content.length > 0) {
                    this.unverifiedUsers = response.data.responseData.content
                    this.totalItems = response.data.responseData.totalElements
                }
            }).catch((error) => {
                console.error(error);
                this.$store.dispatch('stop_loading');
            }).finally(() => {
                this.$store.dispatch('stop_loading');
            });
        },
        async fetchSingleData() {
          let size = this.perPage == null ? 10 : this.perPage;
          let page = this.currentPage == null ? 0 : this.currentPage - 1

          if(!this.isAdvanced) {
            this.searchedLastName = null;
            this.searchedFirstName = null;
            this.searchedEmail = null;
            this.searchedAfm = null;
          }
          else {
            this.searchedEfsa = null;
          }

          let url = "/admin/search-unverified-users?page=" + page + "&size=" + size + "";
          this.$store.dispatch('loading');
          let data = {};
          //Accent is removed for the first and last names typed by the user
          let firstNameWithoutAccent = this.searchedFirstName == null ? null :
              this.searchedFirstName.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
          let lastNameWithoutAccent = this.searchedLastName == null ? null :
              this.searchedLastName.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
            data = {
              "efsa": this.searchedEfsa,
              "firstName": this.searchedFirstName !== "" ? firstNameWithoutAccent : null,
              "lastName": this.searchedLastName !== "" ? lastNameWithoutAccent : null,
              "email": this.searchedEmail !== "" ? this.searchedEmail : null,
              "afm": this.searchedAfm !=="" ? this.searchedAfm : null
            };

          if(data.firstName != null) data.firstName = data.firstName.toLowerCase();
          if(data.lastName != null) data.lastName = data.lastName.toLowerCase();

          HTTP.post(url, data).then(response => {
            this.unverifiedUsers = response.data.responseData.content
            this.totalItems = response.data.responseData.totalElements
          }).catch((error) => {
            console.error(error);
            this.$bvToast.toast("Υπήρξε κάποιο πρόβλημα", {
              title: `Αδύνατη αναζήτηση`,
              variant: 'danger',
              solid: true
            });
            this.users = []
            this.$store.dispatch('stop_loading');
          }).finally(() => {
            this.$store.dispatch('stop_loading');
          });
        },
        exportChanges() {
            let size = 1000000;
            let page = 0;

            let url = "/admin/download-unverified-users?page=" + page + "&size=" + size + "";
            this.$store.dispatch("loading")
            HTTP.get(url, {
                responseType: 'blob'
            }).then(res => {
                let blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'efedros_unverified_users.xls';
                link.click();
            }).finally(() => this.$store.dispatch("stop_loading"))
        }
    },
  watch: {
      isSearch() {
        if (this.isSearch) {
          this.isAdvanced = false;
        }
      },
    isAdvanced() {
       if (this.isAdvanced) {
         this.isSearch = false;
       }
    }
  }
};
</script>
               